import React from 'react';
import { useState, useRef } from 'react'
import "./RecipeNavigator.css"
import RecipeSearch from './RecipeSearch/RecipeSearch';
import RecipeList from './RecipeList/RecipeList';
import RecipeActiveElement from './RecipeActiveElement/RecipeActiveElement';
import { useData } from "../../DataContext/DataProvider"

function RecipeNavigator({ isVisible = true, isEditable = true, handleEditing }) {

    const activeRef = useRef(null)
    const [activeIndex, setActiveIndex] = useState(-1)

    const [searchInput, setSearchInput] = useState("")
    const dataContext = useData();
    
    const recipesArray = dataContext.recipesData.recipes.filter((recipe) => {
        return recipe.Recipe_Name.toLocaleUpperCase().includes(searchInput?.toLocaleUpperCase())
    })

    const recipes = recipesArray.map((recipe, index) => {
        return {
            ...recipe,
            recipe_index: index
        }
    })

    function handleOutsideClick(e) {
        if (activeRef.current && !activeRef.current.contains(e.target)) {
            setActiveIndex(-1)
            document.removeEventListener("mousedown", handleOutsideClick);
        }
    }

    function activateHandler(index) {
        setActiveIndex(index)
        document.addEventListener("mousedown", handleOutsideClick)
    }
    async function deleteHandler(e) {
        setActiveIndex(-1)
        dataContext.recipesData.deleteRecipe(e)
    }

    return (
        <div className="recipe-navigator-container" ref={activeRef} style={{ display: isVisible ? 'block' : 'none' }}>
            <div className="recipes-search-container">
                <RecipeSearch setSearchInput={setSearchInput}></RecipeSearch>
            </div>
            <div className={activeIndex === -1 ? "active-recipe-container empty" : "active-recipe-container visible-element filled"} style={{
                display: isEditable ? 'block' : 'none'
            }}>
                {
                    recipes.map((recipe, index) => {
                        if (index === activeIndex)
                            return (
                                <RecipeActiveElement recipe={recipe} key={index} index={recipe.recipe_index} handleDelete={deleteHandler} handleEditing={handleEditing} isEditable={isEditable} isActive={true} />
                            )
                        else return null
                    })
                }
            </div>
            <RecipeList recipesArray={recipes} activateHandler={activateHandler} />
        </div>
    );
}

export default RecipeNavigator